var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainSection"},[_c('div',{staticClass:"container"},[_c('Interface',{attrs:{"buttons":_vm.buttons}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }